import { DateTime, DateTimeOptions } from "luxon";
import { isDateTime } from "./isDateTime";

export function getOrParseDateTime(date: DateTime | string, parseOptions: DateTimeOptions = { zone: "utc" }): DateTime {
  return isDateTime(date) ? date : DateTime.fromISO(date, parseOptions);
}
